import { render, staticRenderFns } from "./parametriCarrello.vue?vue&type=template&id=0aa365af&scoped=true&"
import script from "./parametriCarrello.vue.ts?vue&type=script&lang=ts&"
export * from "./parametriCarrello.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa365af",
  null
  
)

export default component.exports